import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ErrorText from './ErrorText';
import Label from './Label';

const SelectInput = ({ name, label, onChange, defaultOption, value, error, touched, options, children, required, classes }) => {
  const wrapperClass = classNames('form-group', classes, {
    'form-group--has-error': touched && error,
  });

  return (
    <div className={wrapperClass}>
      <Label name={name} required={required}>{label}</Label>

      {children}

      <div className="field">
        <select
          id={name}
          name={name}
          className="form-control custom-select"
          value={value}
          onChange={onChange}
        >
          <option value="">{defaultOption}</option>
          {options.map(option => (
            <option key={option.value} value={option.value}>{option.label}</option>
          ))}
        </select>
      </div>

      {touched && error && <ErrorText>{error}</ErrorText>}
    </div>
  );
};

SelectInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  defaultOption: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.number]),
  error: PropTypes.string,
  touched: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.object),
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
  required: PropTypes.bool,
  classes: PropTypes.string,
};

export default SelectInput;



// WEBPACK FOOTER //
// ./library/app/components/Global/Forms/SelectInput.js